import React from 'react';

const SystemArchitectureDiagram: React.FC = () => {
  return (
    <div className="p-6 bg-white rounded-lg shadow-lg transition-all duration-300">
      <h2 className="mb-6 text-2xl font-bold text-center text-blue-800">系统总体架构图</h2>
      <p className="mb-4 text-gray-600 text-center max-w-4xl mx-auto">
        Fusion与X-Ray系统总体架构设计
      </p>
      
      <div className="relative w-full h-[600px] bg-gradient-to-b from-gray-50 to-gray-100 rounded-lg p-6 overflow-hidden">
        <div className="relative mx-auto h-full max-w-5xl">
          {/* 用户访问层 */}
          <div className="mb-8">
            <div className="bg-indigo-100 rounded-lg p-4 border-2 border-indigo-300 shadow-md max-w-2xl mx-auto">
              <h3 className="text-center font-semibold text-indigo-800 mb-3">用户访问层</h3>
              <div className="flex justify-center gap-6">
                <div className="bg-white p-3 rounded shadow-sm text-center border border-indigo-200">
                  <div className="text-sm font-medium">Web端</div>
                </div>
                <div className="bg-white p-3 rounded shadow-sm text-center border border-indigo-200">
                  <div className="text-sm font-medium">移动端</div>
                </div>
                <div className="bg-white p-3 rounded shadow-sm text-center border border-indigo-200">
                  <div className="text-sm font-medium">API访问</div>
                </div>
              </div>
            </div>
          </div>

          {/* API网关层 */}
          <div className="mb-8">
            <div className="bg-purple-100 rounded-lg p-4 border-2 border-purple-300 shadow-md max-w-3xl mx-auto">
              <h3 className="text-center font-semibold text-purple-800 mb-3">API网关层</h3>
              <div className="grid grid-cols-5 gap-2">
                <div className="bg-white p-2 rounded text-center border border-purple-200">
                  <div className="text-sm font-medium">认证授权</div>
                </div>
                <div className="bg-white p-2 rounded text-center border border-purple-200">
                  <div className="text-sm font-medium">协议转换</div>
                </div>
                <div className="bg-white p-2 rounded text-center border border-purple-200">
                  <div className="text-sm font-medium">负载均衡</div>
                </div>
                <div className="bg-white p-2 rounded text-center border border-purple-200">
                  <div className="text-sm font-medium">流量控制</div>
                </div>
                <div className="bg-white p-2 rounded text-center border border-purple-200">
                  <div className="text-sm font-medium">日志监控</div>
                </div>
              </div>
            </div>
          </div>

          {/* 核心系统层 */}
          <div className="mb-8">
            <div className="flex justify-between gap-6">
              {/* Fusion系统 */}
              <div className="flex-1 bg-gradient-to-br from-red-50 to-red-100 rounded-lg p-4 border-2 border-red-300 shadow-md">
                <h3 className="text-center font-semibold text-red-800 mb-3">Fusion系统</h3>
                <div className="space-y-3">
                  <div className="bg-white p-2 rounded shadow-sm border border-red-200">
                    <div className="font-medium text-red-700 text-sm mb-2">业务功能层</div>
                    <div className="grid grid-cols-2 gap-2">
                      <div className="text-xs bg-red-50 p-1 rounded">交易管理</div>
                      <div className="text-xs bg-red-50 p-1 rounded">风险控制</div>
                      <div className="text-xs bg-red-50 p-1 rounded">资金管理</div>
                      <div className="text-xs bg-red-50 p-1 rounded">物流管理</div>
                    </div>
                  </div>
                  <div className="bg-white p-2 rounded shadow-sm border border-red-200">
                    <div className="font-medium text-red-700 text-sm mb-2">技术架构层</div>
                    <div className="grid grid-cols-2 gap-2">
                      <div className="text-xs bg-red-50 p-1 rounded">Spring Boot</div>
                      <div className="text-xs bg-red-50 p-1 rounded">React.js</div>
                      <div className="text-xs bg-red-50 p-1 rounded">MySQL</div>
                      <div className="text-xs bg-red-50 p-1 rounded">Redis</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* X-Ray系统 */}
              <div className="flex-1 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-4 border-2 border-blue-300 shadow-md">
                <h3 className="text-center font-semibold text-blue-800 mb-3">X-Ray系统</h3>
                <div className="space-y-3">
                  <div className="bg-white p-2 rounded shadow-sm border border-blue-200">
                    <div className="font-medium text-blue-700 text-sm mb-2">分析功能层</div>
                    <div className="grid grid-cols-2 gap-2">
                      <div className="text-xs bg-blue-50 p-1 rounded">数据采集</div>
                      <div className="text-xs bg-blue-50 p-1 rounded">实时分析</div>
                      <div className="text-xs bg-blue-50 p-1 rounded">风险预警</div>
                      <div className="text-xs bg-blue-50 p-1 rounded">策略回测</div>
                    </div>
                  </div>
                  <div className="bg-white p-2 rounded shadow-sm border border-blue-200">
                    <div className="font-medium text-blue-700 text-sm mb-2">技术架构层</div>
                    <div className="grid grid-cols-2 gap-2">
                      <div className="text-xs bg-blue-50 p-1 rounded">Python</div>
                      <div className="text-xs bg-blue-50 p-1 rounded">FastAPI</div>
                      <div className="text-xs bg-blue-50 p-1 rounded">ClickHouse</div>
                      <div className="text-xs bg-blue-50 p-1 rounded">Kafka</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 基础设施层 */}
          <div>
            <div className="bg-gray-100 rounded-lg p-4 border-2 border-gray-300 shadow-md max-w-4xl mx-auto">
              <h3 className="text-center font-semibold text-gray-800 mb-3">基础设施层</h3>
              <div className="grid grid-cols-4 gap-4">
                <div className="bg-white p-2 rounded text-center border border-gray-200">
                  <div className="text-sm font-medium">容器编排</div>
                  <div className="text-xs text-gray-500">Docker/K8s</div>
                </div>
                <div className="bg-white p-2 rounded text-center border border-gray-200">
                  <div className="text-sm font-medium">服务网格</div>
                  <div className="text-xs text-gray-500">Istio</div>
                </div>
                <div className="bg-white p-2 rounded text-center border border-gray-200">
                  <div className="text-sm font-medium">监控告警</div>
                  <div className="text-xs text-gray-500">Prometheus</div>
                </div>
                <div className="bg-white p-2 rounded text-center border border-gray-200">
                  <div className="text-sm font-medium">日志分析</div>
                  <div className="text-xs text-gray-500">ELK Stack</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="mt-6 p-4 bg-blue-50 rounded-lg shadow-sm">
        <h3 className="font-semibold text-blue-800 mb-2">系统架构说明</h3>
        <p className="text-sm text-gray-700">
          系统采用现代化微服务架构，分为用户访问层、API网关层、核心系统层和基础设施层。Fusion系统采用Java技术栈，专注于交易执行和风险管理；
          X-Ray系统采用Python技术栈，提供数据分析和决策支持。两个系统通过消息队列和API进行通信，共享部分基础设施，但保持独立部署和运行。
          整体架构采用容器化部署，使用Kubernetes进行编排管理，确保系统的高可用性和可扩展性。
        </p>
      </div>
    </div>
  );
};

export default SystemArchitectureDiagram; 